// ScrollToTop.jsx
import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const rafRef = useRef(null);
  const timeoutRef = useRef(null);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return undefined;

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const targets = [
      window,
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.getElementById("root"),
    ].filter(Boolean);

    const scrollToTop = () => {
      targets.forEach((target) => {
        if (target === window) {
          window.scrollTo(0, 0);
          return;
        }
        if (typeof target.scrollTo === "function") {
          target.scrollTo(0, 0);
        }
        if ("scrollTop" in target) target.scrollTop = 0;
        if ("scrollLeft" in target) target.scrollLeft = 0;
      });
    };

    scrollToTop();
    rafRef.current = requestAnimationFrame(() => {
      scrollToTop();
      timeoutRef.current = setTimeout(scrollToTop, 50);
    });

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default ScrollToTop;
